/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import OnuPonInfoTable from '@app/utils/OnuPonInfoTable'
import Translate from '../components/translate/conf';
const OnuPonInfoPage = (props) => {
    return (
      <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1><Translate transVar='menusidebar.label.ONU.PONInfo'/></h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Translate transVar='menusidebar.label.ONU.Parent' />
                </li>
                <li className="breadcrumb-item active">
                  <Translate transVar='menusidebar.label.ONU.PONInfo' />
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
          <div className="container-fluid">
              <div className="card">
                  <div className="card-body">
                      <OnuPonInfoTable {...props} />
                  </div>
              </div>
          </div>
      </section>
  </div>
    );
};

export default OnuPonInfoPage;
